var _mask, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAuto(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 94,
    height: 94
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H90C92.2091 0 94 1.79086 94 4V90C94 92.2091 92.2091 94 90 94H4C1.79086 94 0 92.2091 0 90V4Z",
    fill: "#2B3253"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H94V94H0V0Z",
    fill: "#FF6F4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7 20H34.1673C38.8556 20 43.0286 22.9715 44.5622 27.4018L51 46H-7V20Z",
    fill: "#BE4E34"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M-7 46H51L82 66H-7V46Z",
    fill: "#BE4E34"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.35,
    x: -7,
    y: 66,
    width: 89,
    height: 29,
    fill: "#BE4E34"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -3,
    y: 79,
    width: 42,
    height: 5,
    rx: 2.5,
    fill: "#BE4E34"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 81,
    r: 7,
    fill: "#BE4E34"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuto);
export default __webpack_public_path__ + "static/media/auto.16970a9f4d16d2909ac27c825c5e1158.svg";
export { ForwardRef as ReactComponent };